module.exports = __webpack_public_path__ + "img/cafe.6a42175a.svg";